import React from 'react';
import cx from 'classnames';
import { PropTypes } from 'prop-types';
import { Icon } from '@unite-us/ui';
var SecondaryButton = function SecondaryButton(_ref) {
  var ariaLabel = _ref.ariaLabel,
    className = _ref.className,
    dataTestId = _ref['data-testid'],
    disabled = _ref.disabled,
    icon = _ref.icon,
    label = _ref.label,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("button", {
    className: cx(className, 'flex p-2 border border-solid border-dark-pale-blue rounded space-x-2', disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-pale-blue'),
    "data-testid": dataTestId,
    type: "button",
    "aria-label": ariaLabel || label,
    onClick: onClick,
    disabled: disabled
  }, icon ? /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    className: cx('fill-current text-current-blue', disabled && 'opacity-50')
  }) : null, /*#__PURE__*/React.createElement("span", {
    className: cx('text-current-blue', disabled && 'opacity-50')
  }, label));
};
SecondaryButton.propTypes = {
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  'data-testid': PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  label: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired
};
SecondaryButton.defaultProps = {
  ariaLabel: '',
  className: '',
  disabled: false,
  icon: '',
  'data-testid': undefined
};
export default SecondaryButton;
//# sourceMappingURL=SecondaryButton.js.map